module.exports = __webpack_public_path__ + "img/ESPN_ANALYTICS_1.8ff3bb31.png";